
























































































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import ColorButton from './ColorButton/ColorButton.vue';
import userInterface from './interface/user';
import Storage from './localStorage/storage';
import Btn from './Button/Btn.vue';
import resultInterface from './interface/result';
import playSound from '../utils/sounds';

const storage = new Storage();

@Component({
  computed: {
    ...mapGetters(['getUsers', 'getCurrentName', 'getResult', 'getCountOfGames']),
  },
  components: {
    'color-button': ColorButton,
    Btn,
  },
})
export default class Lobby extends Vue {
  @Prop({ default: [] }) private users!: userInterface[];

  getResult!: resultInterface[];

  getCountOfGames!: number;

  loginTitle = 'Введите своё имя';

  namePlaceholder = 'Введите своё имя';

  displayResult = false;

  get checkResultLength(): boolean {
    return this.getResult.length > 0;
  }

  get arrayNames(): string[] {
    return this.users.map((user: userInterface) => user.name);
  }

  get usedColors(): string[] {
    return this.users.map((user: userInterface) => user.color);
  }

  get currentColor(): string {
    let color = this.users.find((u) => u.name === this.currentName)?.color;
    if (!color) color = '';
    return color;
  }

  @Watch('currentColor') onColorChange(): void {
    storage.data.color = this.currentColor;
    storage.saveData();
  }

  userName = '';

  userReady = false;

  currentName = storage.data.name;

  mounted(): void {
    if (this.currentName) {
      this.userName = this.currentName;
      this.userReady = this.users.find((u) => u.name === this.userName)?.ready || false;
    }
  }

  addNewUser(): void {
    this.userName = this.userName.trim();
    if (this.userName !== '' && !this.arrayNames.includes(this.userName)) {
      this.currentName = this.userName;
      storage.data.name = this.currentName;
      storage.saveData();
      this.$emit('add-new-user', this.currentName, this.usedColors);
    }
  }

  toggleStatus(): void {
    this.userReady = !this.userReady;
    this.$emit('toggle-status', this.currentName);
  }

  setNewColor(color: string): void {
    storage.data.color = color;
    storage.saveData();
    this.$emit('set-new-color', this.currentName, color);
  }

  quitLobby(): void {
    this.$socket.emit('deleteUser', this.userName);
  }

  clearInput(): void {
    this.userName = '';
    storage.data.name = this.userName;
    storage.saveData();
  }

  playSound = playSound;

  playBtnSound(): void {
    this.playSound('button');
  }
}
